import React from "react";

// Props type definition
type PartyAmountInfoCellProps = {
  value?: string | number;
};

// Format function
const formatAmount = (amount?: string | number): string => {
  if (!amount) return "0.00";

  // Convert to number if it's a string
  const numericAmount =
    typeof amount === "string" ? parseFloat(amount) : amount;

  return (numericAmount / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Reusable component
const PartyAmountInfoCell: React.FC<PartyAmountInfoCellProps> = ({ value }) => {
  return <span>{formatAmount(value)}</span>;
};

export default PartyAmountInfoCell;
